import { Component, h } from 'preact'
import IdeaCard from './ideaCard'
import { Idea } from '../Types'

const headerHeight = 56

interface Props {
  ideaStatusTitle: string
  ideaList: Idea[]
  maxHeight: number
  currentUserId: number
  totalTopicCount: number
  isGuest: boolean
}

class IdeationColumn extends Component<Props> {
  getWrapperStyles () {
    return {
      'max-height': this.props.maxHeight - headerHeight, // height of the header
      'overflow-y': 'scroll'
    }
  }

  render ({ ideaStatusTitle, ideaList, currentUserId, isGuest, totalTopicCount }: Props) {
    if (ideaList.length < 1) return null

    return (
      <div className='pipeline__column-wrapper'>
        <div className='pipeline__column-header'>
          <h5 className='pipeline__column-title'>
            {ideaStatusTitle} {totalTopicCount > 0 ? `(${totalTopicCount})` : ''}
          </h5>
        </div>
        <div className='pipeline__ideation-list-wrapper' style={this.getWrapperStyles()}>
          {ideaList.map((idea: Idea) => {
            return (
              <IdeaCard
                key={idea.id}
                voteSet={idea.voteSet}
                currentUserId={currentUserId}
                title={idea.title}
                ideaId={idea.id}
                publicId={idea.publicId}
                author={idea.author}
                votes={idea.votes}
                isGuest={isGuest}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

export default IdeationColumn
